<DataGridView DataUrl="/Backend/Api/V2/Admin/GeraeteModell/List" #Grid KeyProperty="key">
  <DataGridViewColumn field="bezeichnung" header="Bezeichnung" />
  <DataGridViewColumn field="rate" header="Rate" />
  <DataGridViewColumn field="preis" header="Preis" />
  <DataGridViewColumn field="hilfsmittelnummer" header="Hilfsmittelnummer" />
  <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Gerät Modell">
        <ng-template #staticContent>
          <GeraeteModelEdit [Key]="row?.key"></GeraeteModelEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
    <ng-template #header>
      <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Gerät Modell">
        <ng-template #staticContent>
          <GeraeteModelEdit></GeraeteModelEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
